import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { ColumnDefinition, ensureDexieReady, getDataFromDexie } from '../../../db/DexieServises';
import DynamicTable from '../../../db/DynamicTable';
import CardHeaderSpan from '../../../Utils/CommonComponents/CardHeaderSpan';

// Master table keys
const masterKeys = ['User','Employee', 'Position', 'OrgUnit', 'Branch', 'Grade', 'Designation','RolePerms', 'Classification'];

interface TableBundle {
  tableName: string;
  columns: ColumnDefinition[];
  data: Record<string, any>[];
}

export default function DebugDashboard() {
  const [tables, setTables] = useState<TableBundle[]>([]);

  useEffect(() => {
    const loadAllTables = async () => {
      const results: TableBundle[] = [];
      await ensureDexieReady();

      for (const tableName of masterKeys) {
        const schemaJson = localStorage.getItem(`schema_${tableName}`);
        if (!schemaJson) {
          console.warn(`⚠️ No schema found for ${tableName}`);
          continue;
        }

        const columns: ColumnDefinition[] = JSON.parse(schemaJson);
        const data = await getDataFromDexie(tableName);

        // console.log(`📦 Retrieved ${data.length} records from ${tableName}`);
        results.push({ tableName, columns, data });
      }

      setTables(results);
    };

    loadAllTables();
  }, []);

  // 🔘 Copy all table data to clipboard
  const handleDumpAll = () => {
    const dump = tables.reduce((acc, table) => {
      acc[table.tableName] = table.data;
      return acc;
    }, {} as Record<string, any[]>);

    navigator.clipboard.writeText(JSON.stringify(dump, null, 2)).then(() => {
      alert('📋 All table data copied to clipboard');
    }).catch((err) => {
      console.error('❌ Failed to copy data:', err);
      alert('❌ Failed to copy data. See console for error.');
    });
  };

  return (
    <Fragment>
      <Container className="default-dashboard" fluid>
        <Row className="mb-3">
          <Col>
            <Button color="info" onClick={handleDumpAll}>
              🧾 Dump All Table Data
            </Button>
          </Col>
        </Row>
        <Row>
          {tables.map((table, index) => (
            <Col xs="12" key={index} className="mb-4">
              <CardHeaderSpan heading={table.tableName} />
              <DynamicTable columns={table.columns} data={table.data} />
            </Col>
          ))}
        </Row>
      </Container>
    </Fragment>
  );
}
